import Icon from '../components/Icon.vue'

Icon.register({
  'shopping-cart': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528.1 301.3L575.4 93.3C578.8 78.3 567.4 64 552 64H159.2L150 19.2C147.8 8 137.9 0 126.5 0H24C10.7 0 0 10.7 0 24V40C0 53.3 10.7 64 24 64H93.9L164.1 407.4C147.3 417.1 136 435.2 136 456 136 486.9 161.1 512 192 512S248 486.9 248 456C248 440.3 241.6 426.2 231.2 416H440.8C430.4 426.2 424 440.3 424 456 424 486.9 449.1 512 480 512S536 486.9 536 456C536 433.8 523.1 414.7 504.4 405.6L509.9 381.3C513.4 366.3 501.9 352 486.5 352H218.1L211.6 320H504.7C515.9 320 525.6 312.2 528.1 301.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shopping-cart.js
// module id = jhGE
// module chunks = 144